import { StarFilled } from '@ant-design/icons';
import { Marker } from 'react-map-gl/mapbox';

interface ShopMarkerProps {
  latitude: number;
  longitude: number;
}

const ShopMarker = ({ latitude, longitude }: ShopMarkerProps) => {
  const pinStyle = {
    width: '30px',
    height: '30px',
    backgroundColor: '#CCCCCC',
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    border: '2px solid #000000',
    boxShadow: '0 2px 4px rgba(0,0,0,0.3)'
  } as const;

  return (
    <Marker
      latitude={latitude}
      longitude={longitude}
      anchor="center"
    >
      <div style={pinStyle}>
        <StarFilled style={{ color: '#000000', fontSize: '16px' }} />
      </div>
    </Marker>
  );
};

export default ShopMarker; 